import React, { useRef, useState } from 'react';

export const PinInput = ({ value, onChange, length = 4, disabled = false }) => {
  const [digits, setDigits] = useState(value ? value.split('') : Array(length).fill(''));
  const inputRefs = useRef([]);

  const handleChange = (index, newValue) => {
    if (!/^\d*$/.test(newValue)) return; // Only allow digits
    
    const newDigits = [...digits];
    newDigits[index] = newValue.slice(-1); // Take only last character
    setDigits(newDigits);
    
    const fullPin = newDigits.join('');
    onChange(fullPin);
    
    // Auto-focus next input
    if (newValue && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !digits[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, length);
    const newDigits = pastedData.split('').concat(Array(length).fill('')).slice(0, length);
    setDigits(newDigits);
    onChange(newDigits.join(''));
    
    // Focus the appropriate input
    const focusIndex = Math.min(pastedData.length, length - 1);
    inputRefs.current[focusIndex]?.focus();
  };

  return (
    <div className="pin-input-container" data-testid="pin-input-container">
      {digits.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (inputRefs.current[index] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          disabled={disabled}
          className="pin-digit"
          data-testid={`pin-digit-${index}`}
          aria-label={`PIN digit ${index + 1}`}
        />
      ))}
    </div>
  );
};

export default PinInput;
